import { render, staticRenderFns } from "./BackgroundVideoCustoms.vue?vue&type=template&id=20cef4db"
import script from "./BackgroundVideoCustoms.vue?vue&type=script&lang=js"
export * from "./BackgroundVideoCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports